export function readyEnemy(bull){
    return{
        type:'READY_ENEMY',
        payload:bull
    }
}